<ng-template #groupingSelectTmpl>
  <rt-select2
    [formControl]="groupControl().controls.configId"
    [items]="groupingItems"
    [style.width]="DropdownWidth.Medium"
    alwaysOpen
    (click)="mainDropdown.prevTemplate()"
    (uiItemSelect)="viewsAnalytics.groupBySelect({ groupBy: $any($event).value })"
  >
    <rt-select-header>
      <rt-icon-button
        prefix
        [iconName]="'arrow-back'"
        size="small"
        variant="plain"
        (click)="mainDropdown.prevTemplate()"
      />
      {{ 'app.views.groups.group_by' | translate }}
    </rt-select-header>
    <ng-template rtSelectTrigger />
  </rt-select2>
</ng-template>

<ng-template #hideGroupsTemplate>
  <rt-select2
    [formControl]="groupControl().controls.hidden"
    [items]="groupItems"
    [searchControl]="groupSearch"
    [disableLocalSearch]="true"
    (vsEnd)="groupScrollEnd.next($event)"
    [style.width]="DropdownWidth.Medium"
    alwaysOpen
    withSearch
    withMultiselect
  >
    <rt-select-header>
      <rt-icon-button
        prefix
        [iconName]="'arrow-back'"
        size="small"
        variant="plain"
        (click)="mainDropdown.prevTemplate()"
      />
      {{ 'app.views.view_settings.visible_groups' | translate }}
    </rt-select-header>
    <ng-template [rtSelectHeaderTemplate]="10">
      <rt-dropdown-item (click)="onGroupsSelectAllClick()">
        <rt-checkbox
          prefix
          [checked]="groupsSelectAllState === 'all'"
          [indeterminateState]="groupsSelectAllState === 'indeterminate'"
          [hasMargin]="false"
          (valueChange)="onGroupsSelectAllClick()"
        ></rt-checkbox>
        {{ 'app.views.view_settings.select_all' | translate }}
      </rt-dropdown-item>
    </ng-template>
    <ng-template rtSelectTrigger />
    <rt-select-list-item-multi [reverseSelection]="true" />
  </rt-select2>
</ng-template>

<ng-template #groupingTmpl>
  <rt-dropdown-header>
    @if (hasBackButton()) {
      <rt-icon-button
        prefix
        [iconName]="'arrow-back'"
        size="small"
        variant="plain"
        (click)="mainDropdown.prevTemplate()"
      />
    }
    {{ 'app.views.view_settings.groups' | translate }}
  </rt-dropdown-header>
  <rt-dropdown-item
    [targetFor]="groupingSelectTmpl"
    [dropdownComponentRef]="mainDropdown"
    (click)="viewsAnalytics.settingsGroupByOpen({ origin: 'settings' })"
  >
    <rt-icon prefix name="auto-awesome-motion" />
    <div layout-vertical>
      <div layout layout-space-between>
        <span>{{ 'app.views.groups.group_by' | translate }}</span>
        <rt-icon name="chevron-right" />
      </div>
      <span text-small text-weight-default text-color>
        {{
          selectedGrouping
            ? selectedGrouping.name
            : ('app.views.view_settings.not_grouped' | translate)
        }}
      </span>
    </div>
  </rt-dropdown-item>
  <rt-dropdown-item
    [rtTooltip]="'app.views.view_settings.visible_groups_disabled_tooltip' | translate"
    [rtTooltipEnabled]="!selectedGrouping"
    [rtTooltipPosition]="'left'"
    [class.item-disabled]="!selectedGrouping"
    [targetFor]="selectedGrouping ? hideGroupsTemplate : undefined"
    [dropdownComponentRef]="mainDropdown"
    (click)="selectedGrouping && viewsAnalytics.settingsVisibleGroupsOpen()"
  >
    <rt-icon prefix name="remove-red-eye" />
    <div layout-vertical>
      <div layout layout-space-between>
        <span>{{ 'app.views.view_settings.visible_groups' | translate }}</span>
        <rt-icon name="chevron-right" />
      </div>
      <span text-small text-weight-default text-color>
        {{ 'app.views.view_settings.visible_groups_description' | translate }}
      </span>
    </div>
  </rt-dropdown-item>
  <rt-dropdown-item
    [rtTooltip]="'app.views.view_settings.visible_groups_disabled_tooltip' | translate"
    [rtTooltipEnabled]="!selectedGrouping"
    [rtTooltipPosition]="'left'"
    [class.item-disabled]="!selectedGrouping"
    (click)="onHideEmptyGroupsClick()"
  >
    <rt-icon prefix name="visibility-off" />
    {{ 'app.views.view_settings.hide_empty_groups' | translate }}
    <rt-toggle
      suffix
      [checked]="groupControl().value!.hideEmpty!"
      (click)="onHideEmptyGroupsClick()"
    />
  </rt-dropdown-item>
</ng-template>

<rt-dropdown-item [targetFor]="groupingTmpl" (click)="viewsAnalytics.settingsGroupsOpen()">
  <rt-icon prefix name="auto-awesome-motion" />
  <div layout-vertical>
    <div layout layout-space-between>
      <span>{{ 'app.views.view_settings.groups' | translate }}</span>
      <rt-icon name="chevron-right" />
    </div>
    <span text-small text-weight-default text-color class="description">
      {{
        selectedGrouping
          ? ('app.views.view_settings.group_by_x' | translate: { groupName: selectedGrouping.name })
          : ('app.views.view_settings.not_grouped' | translate)
      }}
    </span>
  </div>
</rt-dropdown-item>
